import * as controlPanelTypes from '@/store/actions/controlPanel'

// initial state
const state = {
  controlPanelOpen: false,
  ampladaControlPanel: 0
}

// getters
const getters = {
  [controlPanelTypes.CONTROL_PANEL_IS_OPEN]: state => state.controlPanelOpen
}

// actions
const actions = {
  [controlPanelTypes.CONTROL_PANEL_TOGGLE] ({ commit, state }) {
    commit(controlPanelTypes.CONTROL_PANEL_TOGGLE)
  },
  [controlPanelTypes.CONTROL_PANEL_CLOSE] ({ commit, state }) {
    commit(controlPanelTypes.CONTROL_PANEL_CLOSE)
  }
}

// mutations
const mutations = {
  [controlPanelTypes.CONTROL_PANEL_TOGGLE] (state) {
    state.controlPanelOpen = !state.controlPanelOpen
  },
  [controlPanelTypes.CONTROL_PANEL_CLOSE] (state) {
    state.controlPanelOpen = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/controlPanel.js